var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstaIconMedia(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.5 1H5.5C4.43913 1 3.42172 1.42143 2.67157 2.17157C1.92143 2.92172 1.5 3.93913 1.5 5V15C1.5 16.0609 1.92143 17.0783 2.67157 17.8284C3.42172 18.5786 4.43913 19 5.5 19H15.5C16.5609 19 17.5783 18.5786 18.3284 17.8284C19.0786 17.0783 19.5 16.0609 19.5 15V5C19.5 3.93913 19.0786 2.92172 18.3284 2.17157C17.5783 1.42143 16.5609 1 15.5 1Z",
    stroke: "#1C2321",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.5 14C11.5609 14 12.5783 13.5786 13.3284 12.8284C14.0786 12.0783 14.5 11.0609 14.5 10C14.5 8.93913 14.0786 7.92172 13.3284 7.17157C12.5783 6.42143 11.5609 6 10.5 6C9.43913 6 8.42172 6.42143 7.67157 7.17157C6.92143 7.92172 6.5 8.93913 6.5 10C6.5 11.0609 6.92143 12.0783 7.67157 12.8284C8.42172 13.5786 9.43913 14 10.5 14Z",
    stroke: "#1C2321",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16 5.5C16.2652 5.5 16.5196 5.39464 16.7071 5.20711C16.8946 5.01957 17 4.76522 17 4.5C17 4.23478 16.8946 3.98043 16.7071 3.79289C16.5196 3.60536 16.2652 3.5 16 3.5C15.7348 3.5 15.4804 3.60536 15.2929 3.79289C15.1054 3.98043 15 4.23478 15 4.5C15 4.76522 15.1054 5.01957 15.2929 5.20711C15.4804 5.39464 15.7348 5.5 16 5.5Z",
    fill: "#1C2321"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaIconMedia);
export default __webpack_public_path__ + "static/media/InstaIconMedia.bbe73f6554355772ab0e854f0ff2ba94.svg";
export { ForwardRef as ReactComponent };